 import axios from 'axios'
 // import store from './../store'

 const baseDomain = process.env.VUE_APP_API_BASE_URL
 const baseURL = `${baseDomain}/api`
console.log('baseURL ', baseURL)
 var axiosConnection = axios.create({
    baseURL,
   // headers: { Authorization: `Bearer ${store.state.jwtToken}` },
 })

  axiosConnection.interceptors.request.use((config) => {
    // We are importing store before it is populated.
    // We intercept the request and use the current apiKey
    var jwtToken = window.localStorage.getItem('jwtToken')
    // config.headers = { Authorization: `Bearer ${store.state.jwtToken}` }
    config.headers = { Authorization: `Bearer ${jwtToken}` }
    return config
   })

   axiosConnection.interceptors.response.use(undefined, function (err) {
    return new Promise(function (resolve, reject) {
      if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        this.$store.commit('LOGOUT')
      }
      throw err
    })
  })

 export default axiosConnection
